export const FETCH_USERINFO_INIT = "FETCH_USERINFO_INIT";
export const INIT_CREATE_USER_SCREEN = "INIT_CREATE_USER_SCREEN";

export const FETCH_USERS_LIST = {
  START: "FETCH_USERS_LIST_START",
  SUCCESS: "FETCH_USERS_LIST_SUCCESS",
  ERROR: "FETCH_USERS_LIST_ERROR",
};

export const FETCH_USERS_DETAIL = {
  START: "FETCH_USERS_DETAIL_START",
  SUCCESS: "FETCH_USERS_DETAIL_SUCCESS",
  ERROR: "FETCH_USERS_DETAIL_ERROR",
};

export const UPDATE_USER = {
  START: "UPDATE_USER_START",
  SUCCESS: "UPDATE_USER_SUCCESS",
  ERROR: "UPDATE_USER_ERROR",
};

export const CREATE_USER = {
  START: "CREATE_USER_START",
  SUCCESS: "CREATE_USER_SUCCESS",
  ERROR: "CREATE_USER_ERROR",
};

export const USER_ROLESDD = {
  START: "USER_ROLESDD_START",
  SUCCESS: "USER_ROLESDD_SUCCESS",
  ERROR: "USER_ROLESDD_ERROR",
};

export const FETCH_LOCATIONS_DD = {
  START: "FETCH_LOCATIONS_DD_START",
  SUCCESS: "FETCH_LOCATIONS_DD_SUCCESS",
  ERROR: "FETCH_LOCATIONS_DD_ERROR",
};

export const FETCH_COMPANIES_DD = {
  START: "FETCH_COMPANIES_DD_START",
  SUCCESS: "FETCH_COMPANIES_DD_SUCCESS",
  ERROR: "FETCH_COMPANIES_DD_ERROR",
};

export const TOAST = {
  RESET: "RESET_TOAST",
};

export const USERS_SAVE_TABLE_STATE = "USERS_SAVE_TABLE_STATE";
